import React from 'react';

export default function Step1ProgramType({ formData, onNext }) {
  const { RequestedPlan, PlanType ,Price} = formData;
var requestedPlan= RequestedPlan != undefined ? RequestedPlan :localStorage.getItem('freeRequestedPlan');
var planType= PlanType != undefined ? PlanType :localStorage.getItem('freePlanType');
var price= Price != undefined ? Price :localStorage.getItem('freePrice');
  const requestedPlanText = {
    1: 'فقط تمرین',
    2: 'فقط تغذیه',
    3: 'برنامه کامل (تمرین + تغذیه + مکمل)'
  };

  const planTypeText = {
    0:'رایگان',
    1: 'پلن عادی',
    2: 'پلن پرمیوم'
  };

  return (
    
    <div className="space-y-6">
      <h2 className="text-lg font-bold mb-4">نوع برنامه انتخاب‌شده</h2>

      <div className="bg-gray-100 dark:bg-[#2a2f3b] rounded-xl p-4 space-y-2 text-center">
        <p>
          <span className="font-semibold">برنامه درخواستی: </span>
          {requestedPlanText[requestedPlan] || 'نامشخص'}
        </p>
        <p>
          <span className="font-semibold">نوع پلن: </span>
          {planTypeText[planType] || 'نامشخص'}
        </p>
         <p>
          <span className="font-semibold">هزینه: </span>
  {price?.toLocaleString()} تومان
        </p>
      </div>

      <div className="text-right">
        <button
          onClick={onNext}
          className="w-full p-3 bg-blue-600 rounded-xl border-2 hover:bg-blue-700 text-white px-6 py-2 rounded-xl disabled:opacity-50"
        >
          تایید و ادامه
        </button>
      </div>
    </div>
  );
}
